<template>
    <tr>
      <td class="no_padding drag_drop"><span></span></td>
      <td class="no_padding">
        <input type="checkbox"
               :id="entity.id"
               :value="entity.id"
               @click.stop
               @change="onChange"
               :checked="isChecked"
        />
        <label
            :for="entity.id"
            @click.stop
            v-translate>Vybrat
        </label>
      </td>
      <td :data-th="'MAC adresa' | translate" class="first_data"><strong>{{ entity.macAddress }}</strong></td>
      <td :data-th="'Typ zařízení' | translate">
        <entity-link :id="entity.id_device_type" type="deviceType">{{ entity.device_type_code }}</entity-link>
      </td>
      <td :data-th="'Operátor' | translate">
        <entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link>
      </td>
      <td class="no_padding edit">
          <div class="edit_inner">
            <a
                v-if="$_loggedUser_action_allowed('devices', 'read')"
                class="btn btn_action btn_grey btn_info"
                @click.stop.prevent="showDeviceDetail(entity.id_device)"
                :title="$gettext('O zařízení')"
                target="_blank"
                v-translate>O zařízení</a>
          </div>
      </td>
    </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import links from "../../mixins/links";
import EntityLink from "../../common/EntityLink.vue";

	export default {
		name: "UnregisteredMacAddressRow",
    components: { EntityLink },
    mixins: [rowActions, links],
		data() {
			return {
				moduleName: 'UnregisteredMacAddressRow',
			}
		},
		props: {
			entity: Object,
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/registeredMacAddress/UnregisteredMacAddressRow.vue